import { Link } from 'react-router-dom';

const DualEntryPath = () => {
  return (
    <div className="entry-path-block" data-testid="dual-entry-path">
      <p className="body-text-secondary" data-testid="entry-path-framing">
        One practice, two entry points. We find the gap that is about to become expensive, then carry the decision into controlled execution.
      </p>

      <div className="entry-path-grid">
        <a
          href="#problem-section-anchor"
          className="entry-path-card"
          data-testid="entry-path-founder"
        >
          <p className="entry-path-label">You have a founder or commercial decision to make</p>
        </a>

        <Link
          to="/legal-ai"
          className="entry-path-card"
          data-testid="entry-path-legal"
        >
          <p className="entry-path-label">You hold confidential records and are deciding about AI</p>
        </Link>
      </div>
    </div>
  );
};

export default DualEntryPath;
